import { useRef } from "react"
import { createPortal } from "react-dom"
import { useMount } from "react-use"

import { Box, Button, Text } from "ui-kit/components-branded/index"
import { Popup, PopupRef } from "modules/PsyCatalog/browser-side/ManualSelection/Popup"
import style from "modules/PsyCatalog/browser-side/ManualSelection/banner.module.scss"
import { BannerStorage } from "modules/PsyCatalog/browser-side/ManualSelection/BannerStorage"
import { SURVEY_URL } from "utils/env-management"
import { isBrowser } from "utils/infrastructure/ssg-utils"

export function Banner() {
    const popupRef = useRef<PopupRef>()
    const bannerRef = useRef<HTMLDivElement>(null)
    useMount(() => {
        bannerRef.current?.scrollIntoView({ behavior: "smooth" })
        location.href.includes("manual=1") && BannerStorage.getInstance().setShowBanner()
    })
    return (
        <div ref={bannerRef} className={style.container}>
            <Box className="has-bg-advanced-yellow has-constant-gaps is-small-gaps">
                <Text weight="accent-tablet">
                    Подобрали наиболее подходящих специалистов по&nbsp;вашему запросу. Чтобы
                    показать больше психологов, мы&nbsp;упростили параметры поиска, вы&nbsp;можете
                    донастроить его самостоятельно. Также вы&nbsp;можете{" "}
                    <a
                        target="_blank"
                        className={style.textLink}
                        href={SURVEY_URL}
                        rel="noreferrer"
                    >
                        изменить ответы в&nbsp;анкете
                    </a>{" "}
                    или{" "}
                    <Button isInlineLink isLikeLink onClick={() => popupRef.current?.show()}>
                        запросить ручной подбор
                    </Button>
                    .
                </Text>
            </Box>
            {createPortal(<Popup ref={popupRef} />, document.body)}
        </div>
    )
}

function canBeShown() {
    if (!isBrowser()) return false
    return BannerStorage.getInstance().showBanner || location.href.includes("manual=1")
}

Banner.canBeShown = canBeShown
